import EmailCampaignAudienceContentTab from '../email/EmailCampaignAudienceContentTab';

const componentRegistry = {
  EmailCampaignAudienceTab: EmailCampaignAudienceContentTab,
  EmailCampaignContentTab: EmailCampaignAudienceContentTab
};

export default componentRegistry;
